import dtm from 'scripts/services/dtm';
import {
    getPlayerName,
    formatTabName,
} from '../../probability/controllers/analytics.controller';
import { PROBABILITY_PAGE_TYPE } from 'components/probability/tooltip-handler';

export function getProbabilityModuleName(pageType) {
    switch (pageType) {
        case PROBABILITY_PAGE_TYPE.LEADERBOARD: {
            return 'Leader Board Scorecard';
        }
        case PROBABILITY_PAGE_TYPE.PLAYER_COMPARISON: {
            return 'Player Comparison';
        }
        case PROBABILITY_PAGE_TYPE.LIVE_VIDEO: {
            return 'Watch Live Featured Player Drawer';
        }
        case PROBABILITY_PAGE_TYPE.PLAYER_DETAIL: {
            return 'Player Profile Detail Page';
        }
        default: {
            return pageType;
        }
    }
}

export function sendFullRecapProbabilityClickAnalitycs(type, player, pageType) {
    if (!type || !player) {
        return;
    }

    const moduleName = getProbabilityModuleName(pageType);

    dtm.trackFullRecapProbabilityChartClick(
        getPlayerName(player),
        formatTabName(type),
        moduleName,
    );
}

export function sendProbabilityChartArrowClickAnalytics(type, player) {
    if (!type || !player) {
        return;
    }

    dtm.trackProbabilityChartArrowClick(
        getPlayerName(player),
        formatTabName(type),
    );
}
